<a class="category-button" [routerLink]="['explore/previously-featured', category.category]">{{ category.name }}</a>
